// Listing photos are uploaded straight from drones (3–5 MB JPEGs). On Vercel we
// route them through the built-in image optimizer (configured under "images" in
// vercel.json) so cards download a ~50 KB WebP sized for the card instead.
// Widths must match images.sizes in vercel.json.
export const CARD_IMAGE_WIDTHS = [384, 640, 828];

const OPTIMIZABLE_HOST = 'rkgdcmsrsouubhysulri.supabase.co';

const canOptimize = (url) => {
  if (typeof window === 'undefined' || !url) return false;
  const host = window.location.hostname;
  // The optimizer only exists on Vercel deployments, not in local dev/serve.
  if (host === 'localhost' || host === '127.0.0.1') return false;
  try {
    return new URL(url).hostname === OPTIMIZABLE_HOST;
  } catch {
    return false;
  }
};

export const optimizedImageUrl = (url, width, quality = 70) =>
  canOptimize(url)
    ? `/_vercel/image?url=${encodeURIComponent(url)}&w=${width}&q=${quality}`
    : url;

export const optimizedImageSrcSet = (url, widths = CARD_IMAGE_WIDTHS) =>
  canOptimize(url)
    ? widths.map((w) => `${optimizedImageUrl(url, w)} ${w}w`).join(', ')
    : undefined;
